import axiosInstance from '../axiosInterceptor/axiosInstance'

const getSubscriptionDetails = async (data) => {
  const { orgId } = data
  const url = `v1/orgs/${orgId}/billing/details`
  const response = await axiosInstance.get(url)
  return response?.data
}

export default getSubscriptionDetails
